import React, { useEffect, useState } from 'react'


export default function Loader() {




  return (
    <div className='addressloader-main'>
      <div className="addressloader"></div>
    </div>
  )
}